__turbopack_context__.v({
  "backdrop": "expandable-cases-module__JeKOca__backdrop",
  "block": "expandable-cases-module__JeKOca__block",
  "blockLabel": "expandable-cases-module__JeKOca__blockLabel",
  "card": "expandable-cases-module__JeKOca__card",
  "cardOpen": "expandable-cases-module__JeKOca__cardOpen",
  "cardSummary": "expandable-cases-module__JeKOca__cardSummary",
  "cardTitle": "expandable-cases-module__JeKOca__cardTitle",
  "closeGlyph": "expandable-cases-module__JeKOca__closeGlyph",
  "closeMobile": "expandable-cases-module__JeKOca__closeMobile",
  "copy": "expandable-cases-module__JeKOca__copy",
  "eyebrow": "expandable-cases-module__JeKOca__eyebrow",
  "list": "expandable-cases-module__JeKOca__list",
  "media": "expandable-cases-module__JeKOca__media",
  "mediaImage": "expandable-cases-module__JeKOca__mediaImage",
  "modal": "expandable-cases-module__JeKOca__modal",
  "modalBody": "expandable-cases-module__JeKOca__modalBody",
  "modalHeader": "expandable-cases-module__JeKOca__modalHeader",
  "modalImage": "expandable-cases-module__JeKOca__modalImage",
  "modalLayer": "expandable-cases-module__JeKOca__modalLayer",
  "modalMedia": "expandable-cases-module__JeKOca__modalMedia",
  "modalSummary": "expandable-cases-module__JeKOca__modalSummary",
  "modalTitle": "expandable-cases-module__JeKOca__modalTitle",
  "openBtn": "expandable-cases-module__JeKOca__openBtn",
  "stack": "expandable-cases-module__JeKOca__stack",
  "visit": "expandable-cases-module__JeKOca__visit",
  "visitGhost": "expandable-cases-module__JeKOca__visitGhost",
});
